import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { createStyles, makeStyles } from '@mui/styles'

import { Logger, LoggerTypes } from '../../../../utils'
import { AccordionDetails, iconNames, FormTitle } from '../../../../components'
import { FlowTaskCard } from '../FlowTaskCard'
import { FlowConditionCard } from '../FlowConditionCard'
import './style.scss'

const useStyles = makeStyles((theme) =>
  createStyles({
    headerColor: {
      color: theme.palette.secondary.main
    }
  })
)

export const FlowActionsAccordion = ({ currentProject, currentScenario, currentFlowGroup, tasks, conditions }) => {
  const { t } = useTranslation()
  const styleClasses = useStyles()

  const flows = currentFlowGroup?.flows || null

  Logger.trace(LoggerTypes.CONTAINER, 'FlowActionsAccordion.render()', {
    currentProject,
    currentScenario,
    currentFlowGroup,
    flows,
    tasks,
    conditions
  })

  return (
    <div className="FlowActionsAccordion">
      <AccordionDetails style={{ padding: '16px 10px' }}>
        {/* -- tasks -- */}
        <FormTitle
          className={`parameterGroup ${styleClasses.headerColor}`}
          title={t('flowGroups.left.tabs.actions.tasks.title')}
          icon={iconNames.CHECK_OK}
          iconSize={13}
        />
        {(tasks && tasks.length > 0 && tasks.map((task, i) => <FlowTaskCard key={`task-${i}`} task={task} />)) || (
          <span>{t('flowGroups.left.tabs.actions.tasks.not_found')}</span>
        )}
        {/* -- conditions -- */}
        <FormTitle
          className={`parameterGroup ${styleClasses.headerColor}`}
          title={t('flowGroups.left.tabs.actions.conditions.title')}
          icon={iconNames.CONDITION}
          iconSize={16}
          style={{ marginTop: '20px' }}
        />
        {(conditions &&
          conditions.length > 0 &&
          conditions.map((condition, ii) => <FlowConditionCard key={`condition-${ii}`} condition={condition} />)) || (
          <span>{t('flowGroups.left.tabs.actions.conditions.not_found')}</span>
        )}
      </AccordionDetails>
    </div>
  )
}

FlowActionsAccordion.displayName = 'FlowActionsAccordion'

FlowActionsAccordion.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object,
  // -- flowGroup' Actions
  tasks: PropTypes.arrayOf(PropTypes.object),
  conditions: PropTypes.arrayOf(PropTypes.object)
}

FlowActionsAccordion.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  // -- flowGroup' Actions
  tasks: null,
  conditions: null
}
